<div id="layout-wrapper">
  <app-sidebar></app-sidebar>
  <div class="main-content ml-5">
    <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
    </app-topbar>
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>